import { render, staticRenderFns } from "./EbooksItem.vue?vue&type=template&id=01975055&scoped=true&"
import script from "./EbooksItem.vue?vue&type=script&lang=js&"
export * from "./EbooksItem.vue?vue&type=script&lang=js&"
import style0 from "./EbooksItem.vue?vue&type=style&index=0&id=01975055&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01975055",
  null
  
)

export default component.exports